var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalesize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#FFFFFF;stroke:#39526E;stroke-width:37.5;stroke-linecap:round;stroke-miterlimit:10;}\t.st1{fill:none;stroke:#39526E;stroke-width:50;stroke-linecap:square;stroke-miterlimit:10;}\t.st2{fill:none;stroke:#EEA320;stroke-width:50;stroke-miterlimit:10;}\t.st3{fill:#EEA320;stroke:#EEA320;stroke-width:37.5;stroke-miterlimit:10;}\t.st4{fill:#39526E;stroke:#39526E;stroke-width:25;stroke-linecap:round;stroke-miterlimit:10;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1201,1448.7H306.7c-139.4,0-253.5-114.1-253.5-253.5V300.8c0-139.4,114.1-253.5,253.5-253.5H1201  c139.4,0,253.5,114.1,253.5,253.5v894.4C1454.6,1334.6,1340.5,1448.7,1201,1448.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 499.7,
    y1: 481.3,
    x2: 499.7,
    y2: 1111.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 473.4,
    y1: 465.2,
    x2: 1123.4,
    y2: 465.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1229.2,467 1038.6,577 1038.6,356.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "502.5,1223.4 392.4,1032.8 612.5,1032.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalesize);
export default __webpack_public_path__ + "static/media/balesize.5e0a24123bf2bf50ae4c2b96a68f6072.svg";
export { ForwardRef as ReactComponent };